import { useMailboxItemSubject } from "./item/useMailboxItemSubject";
import { useMailboxItemBody } from "./item/useMailboxItemBody";
import { useMailboxItemNotificationMessages } from "./item/useMailboxItemNotificationMessages";
import { useMailboxItemLocation } from "./item/useMailboxItemLocation";
import type { MessageCompose } from "common/types";
import { toAsyncResult } from "../../utils";
import { useVstoInterop } from "../../VstoInterop";

export function useMailboxItem() {
  const loadCustomPropertiesAsync: MessageCompose["loadCustomPropertiesAsync"] = (cb) => {
    toAsyncResult(useVstoInterop().loadCustomPropertiesAsync()).then(cb);
  };

  return {
    subject: { ...useMailboxItemSubject() },
    notificationMessages: { ...useMailboxItemNotificationMessages() },
    body: { ...useMailboxItemBody() },
    location: { ...useMailboxItemLocation() },
    loadCustomPropertiesAsync,
  };
}
